import * as React from 'react';
import { SVGProps } from 'react';

const IconMoleculesSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 7a3.986 3.986 0 0 1-1.077 2.73l3.402 5.346a3 3 0 1 1-1.687 1.074l-3.402-5.345a3.996 3.996 0 0 1-2.472 0l-3.402 5.346a3 3 0 1 1-1.687-1.074L9.077 9.73A4 4 0 1 1 16 7z" />
  </svg>
);
export default IconMoleculesSizeM;
